import { Platform } from "react-native";

import { getBaseURL } from "@/api";

export type MessageFilePath =
  | "attachment"
  | "home-care-plan-pdf"
  | "soap-note-pdf";

export function downloadMessageFile({
  messageId,
  path,
  fetchKey,
}: {
  messageId: string;
  path: MessageFilePath;
  fetchKey: (options: { throwOnError: true }) => Promise<{ data?: unknown }>;
}): void {
  // TODO: support native with Linking.openURL.
  if (Platform.OS !== "web") {
    return;
  }

  // Open before fetching so the browser ties the new tab to the click.
  const downloadWindow = window.open("", "_blank");

  fetchKey({ throwOnError: true })
    .then(({ data: key }) => {
      if (!key) {
        downloadWindow?.close();
        return;
      }
      if (downloadWindow) {
        downloadWindow.location.href = `${getBaseURL()}/clinic/message/${messageId}/${path}/${key}`;
      }
    })
    .catch(() => {
      downloadWindow?.close();
    });
}
